import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook to load the user's persistent Brand-DNA summary (if any).
 * Used across tools (Trends-Hub, FB-Ads-Spy, etc.) to prefill niche / audience.
 * Returns { summary, loading } where summary is null if no DNA exists yet.
 */
export function useBrandDnaSummary() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/brand-dna/chat`);
        if (!cancelled) setSummary(data?.summary || null);
      } catch (_) { /* no DNA yet — that's fine */ }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  return { summary, loading };
}
